document.addEventListener('click', function (event) {

  /* =========================
     BRAND CLICK
  ========================= */

  const brand = event.target.closest('.shop-brand');

  if (brand) {

    event.preventDefault();

    const menu = brand.closest('.shop-mega-menu');

    if (!menu) return;

    const selectedBrand = brand.getAttribute('data-brand');

    const brands = menu.querySelectorAll('.shop-brand');
    const contents = menu.querySelectorAll('.brand-categories');

    brands.forEach(function (item) {
      item.classList.remove('active');
    });

    contents.forEach(function (content) {
      content.classList.remove('active');
    });

    brand.classList.add('active');

    const selectedContent = menu.querySelector(
      '.brand-categories[data-content="' + selectedBrand + '"]'
    );

    if (selectedContent) {
      selectedContent.classList.add('active');
    }

    return;
  }


  /* =========================
     CATEGORY CLICK
  ========================= */

  const category = event.target.closest('.main-category-btn');

  if (category) {

    event.preventDefault();

    const currentCategory = category.closest('.main-category');

    if (!currentCategory) return;

    const brandMenu = currentCategory.closest('.brand-categories');

    if (!brandMenu) return;

    /* Close other categories */

    brandMenu.querySelectorAll('.main-category').forEach(function (item) {

      if (item !== currentCategory) {
        item.classList.remove('open');
      }

    });

    /* Open / close clicked category */

    currentCategory.classList.toggle('open');

    return;
  }

});